module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-scripts/~/babel-runtime/core-js/object/define-property.js
// module id = 226
// module chunks = 0